'use client'

import AppContext from '@/types/context'
import { useContext, useEffect } from 'react'
import { vgwortTracking } from '@/libs/Tracking/Tracking.lib'
import { ConsentContext } from '@/context/ConsentContext'
import { useConsentReady } from '@/hooks/useConsentReady'

export default function VGWortTracking({ context }: { readonly context: AppContext }) {
  const consentReady = useConsentReady()
  const consentContext = useContext(ConsentContext)

  useEffect(() => {
    if (consentReady && consentContext.userConsents?.vgwort && context.metadata?.model?.vgwortTrackingUrl) {
      vgwortTracking(context.metadata.model.internalTrackingUrl)
    }
  }, [consentReady])

  return <></>
}
